__turbopack_context__.v({
  "chatThreadAside": "AdminChatThreadAside-module__shUEoG__chatThreadAside",
  "chatThreadAsideAnimation": "AdminChatThreadAside-module__shUEoG__chatThreadAsideAnimation",
  "chatThreadAside__Content": "AdminChatThreadAside-module__shUEoG__chatThreadAside__Content",
  "chatThreadAside__Header": "AdminChatThreadAside-module__shUEoG__chatThreadAside__Header",
  "chatThreadAside__off": "AdminChatThreadAside-module__shUEoG__chatThreadAside__off",
  "chatThreadGuideFade": "AdminChatThreadAside-module__shUEoG__chatThreadGuideFade",
});
